import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthHeader from '../components/AuthHeader';
import {
  Admin,
  Resource,
  ListGuesser,
  EditGuesser,
  ShowGuesser,
} from 'react-admin';
import { Box, CssBaseline, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { dataProvider } from '../providers/adminDataProvider';
import { PlayLogList } from '../components/admin/PlayLogList';
import { UserList } from '../components/admin/UserList';
import { Dashboard } from '../components/admin/Dashboard';
import { Sidebar } from '../components/admin/Sidebar';

// カスタムレイアウト
const MyLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // ログイン状態チェック
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: '/admin_dashboard' }, replace: true });
    }
  }, [isAuthenticated, navigate]);

  // ログイン中のみ表示
  if (!isAuthenticated) {
    return null; // リダイレクト中は何も表示しない
  }

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      
      {/* サイドバー */}
      <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
      
      {/* メインコンテンツエリア */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          transition: theme => theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {/* ヘッダー */}
        <AppBar 
          position="static" 
          elevation={1}
          sx={{ 
            backgroundColor: 'white',
            color: 'text.primary',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              onClick={handleSidebarToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: 'text.primary' }}>
              学習管理ダッシュボード
            </Typography>
          </Toolbar>
        </AppBar>
        
        {/* React Admin コンテンツ */}
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

function AdminDashboardPage() {
  return (
    <Admin
      dataProvider={dataProvider}
      dashboard={Dashboard}
      layout={MyLayout}
      title="学習管理ダッシュボード"
    >
      <Resource
        name="play_logs"
        list={PlayLogList}
        show={ShowGuesser}
        options={{ label: '再生ログ' }}
      />
      <Resource
        name="users"
        list={UserList}
        show={ShowGuesser}
        options={{ label: 'ユーザー' }}
      />
    </Admin>
  );
}

export default AdminDashboardPage;